import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import {
  useCreateDataFileMutation,
  useLazyGetChaptersQuery,
  useLazyGetCountriesQuery,
  useLazyGetDataFilesQuery,
  useLazyGetLanguagesQuery,
  useLazyGetSubjectsQuery,
  useLazyGetUsersQuery,
} from "@/redux/service";

import { DataTemplateResponse } from "@/redux/datablocks/types";
import { selectCurrentUser } from "@/redux/authentication/selectors";

export const useDataBlockDependencies = (
  dataTemplate: DataTemplateResponse | undefined,
) => {
  const { t } = useTranslation();

  const currentUser = useSelector(selectCurrentUser);
  const [getLanguages] = useLazyGetLanguagesQuery();
  const [getCountries] = useLazyGetCountriesQuery();
  const [getUsers] = useLazyGetUsersQuery();
  const [getSubjects] = useLazyGetSubjectsQuery();
  const [getDataFiles] = useLazyGetDataFilesQuery();
  const [createDataFile] = useCreateDataFileMutation();
  const [getChapters] = useLazyGetChaptersQuery();

  if (!dataTemplate || !currentUser) return;

  return {
    getLanguages,
    getCountries,
    getUsers,
    getSubjects,
    getDataFiles,
    getChapters,
    createDataFile,
    t,
    currentUser,
    dataTemplate,
  };
};
